import React from 'react';
import { Link } from 'react-router-dom';



import { getEnv } from '../../../../lib/utils/getEnv';


const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

export const TOP_FEATURES_TITLES_CONFIG = [
  {
    title: 'Simplify admin for your grooming business',
    altName: 'Dog holder Pata letter and reducing admin',
    description: () => (
      <p>
        Cut your time spent on admin and keep important information at your fingertips.{' '}
        <Link to="/business/features#booking">Manage appointments</Link>, view client details, and{' '}
        <Link to="/business/features#calendar"> organise team schedules</Link>. 
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-with-letters.webp`,
  },
  {
    title: 'Take online bookings even while grooming',
    altName: 'Lady with cat making an online booking using Pata',

    description: () => (
      <p>
        Let clients book your grooming services through
        <Link to="/business/features#marketing"> Pata Marketplace</Link>. With our online booking platform, pet owners
        have 24/7 access to your schedule, making bookings easier for them and stress-free for you.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-using-pata-on-laptop.webp`,
  },
  {
    title: 'Minimise no-shows and late cancellations',
    altName: 'Dog covering eyes following a client no show',
    description: () => (
      <p>
        Take upfront payments and collect card details for later charges with PataPay. You can
        also send automated client reminders, helping to further reduce last-minute cancellations and no-shows. Plus,
        quickly fill empty slots thanks to waiting lists and a smart scheduling tool.
      </p>
    ),

    image: `${VITE_CDN_BASE_URL}/images/image-puppy-covering-face.webp`,
    action: {
      actionText: 'Book a demo',
      onClick: () => {
        window.location = `https://meetings.hubspot.com/pata/demo`;
      },
      buttonType: 'secondary',
    },
  },
  {
    title: 'Easy-to-use booking platform',
    altName: 'Happy pet owner with dog and using Pata to book her grooming appointment',
    description: () => (
      <p>
        Our intuitive pet grooming platform is designed with simplicity in mind, so it’s easy to navigate and manage
        your grooming business. If you do need help or have any questions, Pata’s customer support team is always there
        for you.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-holding-dog-with-laptop.webp`,
  },
  {
    title: 'Get discovered by local pet owners',
    altName: 'A dog having a bath after her owner found a groomer through Pata',
    description: () => (
      <p>
        Join <Link to="/business/features#marketing"> Pata Marketplace </Link>
        to boost your online visibility and attract local clients looking for grooming services. Add photos, reviews,
        and service details to your online profile.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-in-bath.webp`,
    action: {
      actionText: 'Join Pata',
      onClick: () => {
        window.location = `${VITE_PARTNERS_BASE_URL}/sign-up`;
      },
      buttonType: 'primary',
    },
  },
];